import axios, { AxiosInstance } from 'axios';
import {
	WEB_API_URL,
	WEB_API_URL_Q4US,
	WEB_API_URL_PAY,
	WEB_API_URL_SHOPIFY,
} from 'services/constants/env';
import { onError } from './interceptor/onError';
import { onSuccess, onSuccessPay, onSuccessQ4US, onSuccessShopify } from './interceptor/onSuccess';

// ==========================================:
const http: AxiosInstance = axios.create({
	baseURL: WEB_API_URL,
	headers: {
		'Access-Control-Allow-Origin': '*',
		'Content-Type': 'application/json',
		Accept: 'application/json',
	},
});

http.interceptors.request.use(onSuccess);
http.interceptors.response.use((response) => response, onError);

export { http };

// ==========================================:

export const httpQ4US: AxiosInstance = axios.create({
	baseURL: WEB_API_URL_Q4US,
	headers: {
		'Access-Control-Allow-Origin': '*',
		'Content-Type': 'application/json',
		Accept: 'application/json',
	},
});
httpQ4US.interceptors.request.use(onSuccessQ4US);
httpQ4US.interceptors.response.use((response) => response, onError);

/**
 * Payment gateway (`/api/admin/*`, `encryptInvoiceNumber`): operator token as `Bearer`, no
 * `X-Merchant-Id`. `Access-Control-Allow-Origin` is a response header, so it is not sent here.
 */
export const httpPay: AxiosInstance = axios.create({
	baseURL: WEB_API_URL_PAY,
	headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json',
	},
});
httpPay.interceptors.request.use(onSuccessPay);
httpPay.interceptors.response.use((response) => response, onError);

export const httpShopify: AxiosInstance = axios.create({
	baseURL: WEB_API_URL_SHOPIFY,
	headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json',
	},
});
httpShopify.interceptors.request.use(onSuccessShopify);
httpShopify.interceptors.response.use((response) => response, onError);
